import { CreateReservationRequest, DeleteReservationRequest, ReservationsApi } from '@yard/app/api'
import { createApiClient } from '@yard/app/http-client'

class ReservationService {
  private readonly httpClient = createApiClient(ReservationsApi)

  async create(request: CreateReservationRequest) {
    const { data } = await this.httpClient.putReservation(request)

    return data
  }

  async delete(request: DeleteReservationRequest) {
    await this.httpClient.deleteReservation(request)
  }
}

export const reservationService = new ReservationService()
